import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ts-mosaic-editor-mode',
  templateUrl: './mosaic-editor-mode.component.html',
  styleUrls: ['./mosaic-editor-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MosaicEditorModeComponent {
  @Input() editingEnabled: boolean;
  @Output() editingEnabledChanged = new EventEmitter<boolean>();
}
